export default {
  pageTitle: '活动管理',
  pageDesc: '管理当前工作区下的会议/活动（个人空间为本人活动，公司空间为该公司活动）。',
  noAccessAlert: '暂无活动管理权限，请联系管理员授权。',
  searchPlaceholder: '搜索活动名称 / 地点 / 简介',
  addEvent: '举办新活动',
  editEvent: '编辑活动',
  emptyTable: '暂无活动',
  eventName: '活动名称',
  requiresRegistration: '需要报名',
  registrationApproval: '报名审核',
  approvalRequired: '需审核',
  approvalAuto: '免审核',
  eventCity: '活动省市',
  eventAddress: '详细地点',
  eventIntro: '活动简介',
  creator: '创建人',
  createdAt: '创建时间',
  namePlaceholder: '请输入活动名称',
  registrationNeedsApproval: '报名需审核',
  cityPlaceholder: '如：广东省广州市',
  citySelectPlaceholder: '请选择省/市',
  cityAbroadPlaceholder: '国外地址可直接填写',
  cityRequired: '请选择举办城区，或填写国外地址',
  addressPlaceholder: '请输入会议详细地址',
  introPlaceholder: '请输入活动简介',
  nameRequired: '请输入活动名称',
  switchCompanyFirst: '请先切换到公司空间',
  createSuccess: '活动创建成功',
  createFailed: '活动创建失败，请稍后重试',
  createModal: {
    title: '填写活动基础信息',
    startTime: '活动开始时间',
    endTime: '活动结束时间',
    timeRange: '活动时间',
    timeRangeRequired: '请选择活动时间',
    city: '举办城区',
    startRequired: '请选择活动开始时间',
    endRequired: '请选择活动结束时间',
    addressRequired: '请填写活动地点',
    introRequired: '请填写活动简介',
    endAfterStart: '结束时间须晚于开始时间',
    submit: '保存并创建活动'
  },
  createSuccessModal: {
    title: '活动创建成功！',
    desc: '活动基础信息已保存。\n你可以现在前往完善活动页面装修与配置，\n也可以稍后在活动管理中继续编辑。',
    goConfig: '🎨 现在去完成活动配置',
    later: '暂不填写，稍后完成'
  },
  updateSuccess: '活动更新成功',
  loadFailed: '活动详情加载失败，请稍后重试',
  deleteConfirmTitle: '删除确认',
  deleteConfirmMessage: '确定要删除活动「{name}」吗？',
  deleteConfirmOk: '确定删除',
  deleteSuccess: '删除成功',
  eventCreateGate: {
    needEventFirst: '请先完成「活动信息」保存以创建活动，再继续本页操作。'
  },
  wizardNav: {
    primaryAria: '活动向导一级导航',
    primaryEvent: '活动',
    primaryDecoration: '创建装修',
    primaryRegistration: '报名',
    backToList: '返回活动列表',
    close: '关闭',
    /** 二级侧栏标题（设计稿「活动设置」） */
    settingsLabel: '活动设置',
    groupBasic: '基础设置',
    groupRegistration: '报名相关',
    groupPageDecoration: '页面装修',
    groupMore: '更多',
    eventInfo: '活动基础信息',
    location: '地点设置',
    registration: '报名设置',
    registrationForm: '问卷',
    share: '分享设置',
    shareTemplate: '活动分享模板',
    micrositeCreate: '页面装修',
    activityConfig: '活动配置',
    schedule: '会议日程',
    regConfig: '报名配置',
    seatConfig: '座位配置',
    seatRec: '座位编辑',
    transferCfg: '接送配置',
    hotelCfg: '酒店配置',
    diningCfg: '用餐配置',
    pickup: '接送管理',
    dining: '用餐管理',
    seating: '座位管理',
    checkin: '签到管理',
    checkinConfig: '签到配置',
    lotteryScreen: '巨屏抽奖',
    taskManage: '任务管理',
    smsNotifications: '短信通知',
    toggleDecoration: '展开或收起活动配置子菜单'
  },
  eventInfo: {
    pageTitle: '活动基础信息',
    lastSaved: '最后保存时间',
    saveBtn: '保存活动信息',
    sectionBasic: '📋 基本信息',
    helpTitle: '说明',
    helpDesc: '在此页填写活动基本信息、地点与报名设置；活动省市请通过省/市级联选择。'
  },
  eventLocation: {
    pageTitle: '地点设置',
    helpTitle: '说明',
    helpDesc: '设置活动举办的城市与详细地址，将展示在报名页与活动详情中。'
  },
  eventRegistration: {
    pageTitle: '报名设置',
    helpTitle: '说明',
    helpDesc: '开启报名后，用户可提交报名信息；若需审核，请开启「报名需审核」。'
  },
  /** 活动向导 · 分享模板（海报预览/下载，不落库） */
  shareTpl: {
    pageTitle: '活动分享模板',
    generatePoster: '生成分享海报',
    sectionTemplate: '海报模板选择',
    sectionContent: '分享内容设置',
    tplBlue: '经典蓝',
    tplBluePurple: '经典蓝',
    tplDarkTech: '深色科技',
    tplFreshGreen: '清新绿意',
    tplWarmOrange: '暖橙商务',
    shareTitle: '主标题',
    shareTitlePlaceholder: '请输入主标题',
    shareSubtitle: '副标题',
    shareSubtitlePlaceholder: '请输入副标题',
    shareDesc: '副标题',
    shareDescPlaceholder: '请输入副标题',
    hostLabel: '主办方',
    hostPlaceholder: '请输入主办方名称',
    posterCover: '海报头图',
    posterCoverHint: '建议宽高比约 16:9，JPG / PNG，不超过 3M',
    posterCoverUpload: '上传头图',
    posterCoverUploading: '上传中…',
    posterCoverUploadSuccess: '海报头图上传成功',
    posterCoverUploadFailed: '海报头图上传失败，请稍后重试',
    posterCoverClear: '移除头图',
    posterCoverPlaceholder: '请上传头图',
    posterCta: '长按扫码 报名参与活动',
    posterAttr: '本页面由半度云智能会务系统提供',
    qrHidden: '已关闭二维码',
    displayItems: '显示内容',
    showTime: '活动时间',
    showLocation: '活动地点',
    showHost: '主办方',
    showQr: '活动首页二维码',
    shareLink: '分享链接',
    activityLink: '活动链接',
    copy: '复制',
    copySuccess: '链接已复制',
    copyFailed: '复制失败',
    homeLinkHint: '链接指向本活动微站首页，与「页面装修」预览一致',
    noHomeLinkHint: '尚未设置微站首页，请先在「页面装修」中创建并设为首页',
    noHomeLinkPlaceholder: '暂无微站首页链接',
    qrNeedHome: '请先设置微站首页',
    preview: '预览效果',
    downloadPng: '下载海报（PNG）',
    downloadSuccess: '海报已下载',
    downloadFailed: '下载失败，请稍后重试',
    brand: '半度云 · 智能会务系统',
    titleEmptyPlaceholder: '（未填写标题）',
    metaUnset: '暂未设置',
    sectionWechatShare: '微信分享',
    wechatShareTip: '配置好友会话中转发卡片的标题、副标题与封面。与上方海报标题/描述一并保存到活动分享配置。',
    wechatTitle: '分享标题',
    wechatTitlePlaceholder: '可留空，留空则回落为活动名称',
    wechatTitleFallback: '（将使用活动名称）',
    wechatSubtitle: '副标题',
    wechatSubtitlePlaceholder: '选填，显示在标题下方',
    wechatSubtitleFallback: '半度云 · 活动',
    wechatImage: '分享图',
    wechatImageHint: '建议尺寸 500×500px，支持 JPG / PNG，大小不超过 3M',
    wechatImageUpload: '上传分享封面',
    wechatImageUploading: '上传中…',
    wechatImageUploadSuccess: '分享图上传成功',
    wechatImageUploadFailed: '分享图上传失败，请稍后重试',
    wechatImageClear: '移除图片',
    wechatImageTypeError: '仅支持 JPG / PNG 图片',
    wechatImageSizeError: '图片大小不能超过 3M',
    saveShare: '保存分享设置',
    saveShareSuccess: '分享设置已保存',
    saveShareFailed: '分享设置保存失败，请稍后重试',
    wechatPreview: '微信卡片预览',
    wechatThumbPlaceholder: '封面'
  },
  /** 活动向导 · 报名配置（对齐设计稿 vRegSetup） */
  regSetup: {
    tabsLabel: '报名管理',
    tabRecords: '报名记录',
    tabOrders: '订单',
    tabStatistics: '统计',
    questionnaireSettingsHint: '允许修改和关闭报名入口请前往问卷设置，所有关联活动统一生效。',
    sectionBasic: '基础设置',
    sectionAdvanced: '高级设置',
    selectForm: '报名表',
    selectFormHint: '选择本活动使用的问卷表格',
    selectFormPlaceholder: '请选择报名表',
    formStatusDraft: '草稿',
    formRequired: '请选择报名表',
    formLockedTitle: '提示',
    formLockedConfirm: '报名设置已保存，问卷不可更改。',
    saveBindTitle: '确认',
    saveBindConfirm: '选择问卷后不可更改，确认？',
    proxyLockedTip: '🔒 勾选「允许团体报名」后可编辑对接人名单',
    proxyNeedBindTip: '请先点击「保存设置」完成问卷绑定后，再录入对接人名单',
    saveSettingsBtn: '保存设置',
    saveBtn: '保存报名设置',
    saveSuccess: '报名设置已保存',
    saveFailed: '保存失败，请稍后重试',
    loadFormsFailed: '加载问卷列表失败',
    loadFormFailed: '加载问卷设置失败',
    noForms: '暂无问卷，请先在「问卷管理」中创建',
    goFormManage: '前往问卷管理',
    formManageTip: '若无可选报名表，请先在「问卷管理」中新增报名表。',
    goConfigure: '前往配置 →',
    statsPageTitle: '报名统计',
    statsExport: '导出统计报告',
    statsExportSoon: '导出功能即将开放',
    statsNeedForm: '请先在报名配置中绑定问卷后查看统计',
    statsLoadFailed: '加载统计失败，请稍后重试',
    statsTotal: '总报名人数',
    statsSelf: '个人报名',
    statsProxy: '团队报名',
    statsAvgDaily: '平均每日报名',
    statsProxyDist: '社团报名分布',
    statsProxyDistEmpty: '暂无对接人报名数据',
    statsTrend7d: '报名趋势（近7天）',
    statsTrendUnit: '单位：人',
    statsTrendTotal: '7天累计',
    statsTrendAvg: '日均',
    statsTrendPeak: '峰值',
    statsPeopleUnit: '人',
    statsFeeIncome: '费用收入汇总',
    statsFeeRegistration: '报名费',
    statsFeeHotel: '酒店住宿',
    statsFeeMeal: '用餐费',
    statsFeeShuttle: '接送费',
    statsFeePending: '（暂未开放）',
    statsReview: '审核状态',
    statsReviewApproved: '已通过',
    statsReviewPending: '待审核',
    statsReviewRejected: '已拒绝',
    statsDeadlinePrefix: '报名截止时间：{time}',
    statsDeadlineRemainMid: '距截止还有',
    statsDeadlineRemainSuffix: '天',
    statsDeadlineTodayMid: '今天截止',
    statsDeadlinePassedMid: '已截止',
    statsDeadlinePassedSuffix: '天',
    mailTemplate: {
      sectionTitle: '对接邀请邮件模板',
      hint: '每个活动仅一份模板。主题或正文留空时，该侧发信将回退系统默认。可点击下方按钮插入变量。',
      subject: '邮件主题',
      subjectPlaceholder: '{{activityName}} 问卷录入邀请',
      body: '邮件正文',
      bodyPlaceholder: '请输入邮件正文，例如：您好，请通过邀请链接完成问卷录入…',
      insertPlaceholder: '插入变量',
      placeholderHelp: '变量说明',
      phInsertAs: '插入为 {token}',
      imageNotSupported: '邮件正文暂不支持插入图片',
      saveBtn: '保存邮件模板',
      saveSuccess: '邮件模板已保存',
      saveFailed: '保存邮件模板失败',
      loadFailed: '加载邮件模板失败',
      updatedAt: '最近更新：{time}',
      ph: {
        activityName: '活动名',
        formTitle: '报名表单标题',
        recipientName: '对接人姓名',
        magicLinkUrl: '邀请链接',
        linkExpireDays: '链接有效天数',
        appName: '应用名'
      }
    }
  },
  schedule: {
    pageTitle: '会议日程',
    helpTitle: '说明',
    helpDesc: '管理活动下的单场会议/议程，按日期分组展示。',
    add: '添加',
    addAgenda: '添加会议议程',
    edit: '编辑',
    delete: '删除',
    colName: '会议名称',
    colAgendaName: '议程名称',
    colTime: '开始-结束时间',
    colTimeRange: '会议时间段',
    colLocation: '地点',
    colVenue: '座位场地',
    colSortOrder: '排序',
    colIntro: '会议简介',
    colActions: '操作',
    formTitleAdd: '添加会议议程',
    formTitleEdit: '编辑会议议程',
    formSectionBasic: '基础信息',
    formStart: '会议开始',
    formEnd: '会议结束',
    formRegion: '会议区域',
    formAddress: '详细地址',
    formPlace: '地点',
    formSortOrder: '排序',
    regionPlaceholder: '请选择省/市/区',
    regionAbroadPlaceholder: '国外地址可直接填写',
    addressPlaceholder: '请输入详细地址',
    placePlaceholder: '请输入地点',
    sortOrderHint: '同一天内数值越小，排列越靠前；相同数值按开始时间排列。',
    sortOrderInvalid: '排序须为不小于 0 的整数',
    dragSortHint: '拖动调整同一天内的排列顺序',
    sortSaved: '排序已保存',
    sortSaveFailed: '排序保存失败，已恢复原顺序',
    introTip: '如需[装修]会议详情页面，简介的内容会在装修中展示，请选填',
    submitAdd: '确认添加议程',
    submitEdit: '保存议程',
    backToList: '返回列表',
    formHelpDesc: '填写单场会议的名称、时间、地点与简介；带 * 为必填项。',
    emptyList: '暂无会议议程',
    emptyDay: '暂无会议议程',
    unknownDate: '未设置日期',
    activityTimeRangeHint: '根据【活动始末时间】可选时间范围：{range}',
    needActivityTimeFirst: '请先在「活动基础信息」中设置活动开始与结束时间',
    timeOutOfActivityRange: '须在活动起止时间范围内选择',
    nameRequired: '请输入议程名称',
    startRequired: '请选择会议开始时间',
    endRequired: '请选择会议结束时间',
    endAfterStart: '结束时间须晚于开始时间',
    regionRequired: '请选择会议区域，或填写国外地址',
    addressRequired: '请输入详细地址',
    namePlaceholder: '请输入议程名称',
    introPlaceholder: '请输入会议简介',
    createSuccess: '议程添加成功',
    updateSuccess: '议程更新成功',
    saveFailed: '保存失败，请稍后重试',
    deleteConfirmTitle: '删除确认',
    deleteConfirmMessage: '确定要删除这 {count} 条会议议程吗？',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    loadFailed: '加载会议日程失败'
  },
  checkin: {
    tabSettings: '基本设置',
    tabUsers: '签到名单',
    tabFields: '人员展示字段',
    tabSuccess: '成功页设置',
    tabPage: '页面装修',
    create: '新增签到',
    createSuccess: '签到已创建',
    empty: '暂无签到，请先新增',
    name: '签到名称',
    namePh: '请输入签到名称',
    nameRequired: '请输入签到名称',
    colCheckinName: '签到名称',
    colMeeting: '绑定场次',
    colSigned: '已签 / 名单',
    colEntry: '签到入口',
    colScanEntry: '扫码入口',
    meetingNone: '不绑定场次',
    openEdit: '设置',
    copyH5: '复制入口',
    copyEntry: '点击复制',
    qrBtn: '二维码',
    backToList: '返回签到列表',
    deleteConfirmTitle: '删除签到',
    deleteConfirmMessage: '确定删除「{name}」？名单与签到记录将一并删除。',
    deleteSuccess: '签到已删除',
    type: '签到方式',
    typeSearch: '搜索签到',
    typeLocate: '定位签到',
    typeScan: '扫码签到',
    status: '启用状态',
    statusOn: '启用',
    statusOff: '停用',
    needPrint: '需要打印',
    needPrintYes: '是',
    needPrintNo: '否',
    timeWindow: '签到时间窗',
    startTime: '开始时间',
    endTime: '结束时间',
    startAfterActivity: '签到开始时间不能晚于活动开始时间（{time}）',
    startAfterActivityHint: '开始时间不得晚于活动开始时间：{time}',
    address: '签到地址',
    addressPh: '可覆盖活动地址，留空则展示活动地点',
    latitude: '纬度',
    longitude: '经度',
    radius: '半径（米）',
    radiusHint: '定位签到必填',
    customFields: '自定义列',
    fieldKey: '字段标识',
    fieldLabel: '中文名称',
    fieldKeyPh: '例如 company、seat',
    fieldLabelPh: '显示给用户的名称',
    addField: '添加字段',
    fieldsSection: '签到人扩展信息',
    fieldsSectionHint: '配置名单模板、后台列表和签到成功页需要展示的附加资料。',
    fieldsTemplateTip: '保存后请重新下载该签到的名单模板，模板会自动使用这里配置的中文名称。',
    fieldIncomplete: '自定义字段需同时填写字段标识和中文名称',
    fieldKeyInvalid: '字段标识须为英文小写开头，仅含字母、数字和下划线',
    fieldKeyDuplicate: '字段标识不能重复',
    successButtons: '成功页按钮',
    successSection: '签到成功信息按钮',
    successHint: '「跳转链接」填写完整网址；「弹框显示」上传图片。每行最多两个按钮，奇数个时最后一个会自动居中加宽。',
    successImageHint: '二维码建议使用 PNG 或 JPG，四周保留留白；按钮名称建议控制在 8 个字以内。',
    btnName: '按钮名称',
    btnNamePh: '例如：查看活动议程',
    btnNameRequired: '请填写按钮名称',
    btnLink: '跳转链接',
    btnImage: '展示图片',
    btnPopup: '弹框显示',
    btnUrl: 'https://…',
    btnNeedUrl: '第 {n} 个按钮请填写完整跳转链接',
    btnNeedImage: '第 {n} 个弹框按钮请上传图片',
    btnUpload: '上传图片',
    btnReupload: '更换图片',
    btnUploadFailed: '图片上传失败',
    addButton: '添加按钮',
    entryUrls: '公开入口',
    urlH5: '参会者 H5',
    urlScanDesk: '扫码工作台',
    urlPrintDesk: '打印端',
    openQr: '打开二维码',
    entryQrTip: '扫描二维码或复制下方链接打开对应页面',
    save: '保存签到配置',
    saveSuccess: '签到配置已保存',
    copySuccess: '链接已复制',
    copyFailed: '复制失败，请手动复制',
    filterKeyword: '搜索姓名 / 手机号',
    filterStatus: '签到状态',
    statusUnsigned: '未签到',
    statusSigned: '已签到',
    import: '导入',
    export: '导出',
    exportTemplate: '下载模板',
    importTip: 'Excel 须含「姓名」「手机号码」列。自定义列按签到设置填写。同一签到内手机号重复则更新。单次最多 5000 行。',
    importDrop: '拖拽 Excel 到此处，或点击上传',
    importEmpty: '没有可导入的数据行',
    importReady: '已解析 {n} 行，确认后写入',
    importDone: '导入完成：新增 {created}，更新 {updated}，失败 {failed}',
    colName: '姓名',
    colMobile: '手机号',
    phName: '请输入姓名',
    phMobile: '请输入手机号码',
    colStatus: '签到状态',
    colTime: '签到时间',
    colActions: '操作',
    addUser: '新增人员',
    editUser: '编辑人员',
    userNameRequired: '请输入姓名',
    userMobileRequired: '请输入手机号',
    userAddSuccess: '人员已添加',
    userEditSuccess: '人员已保存',
    bgColor: '背景色',
    bgImage: '背景图',
    buttonText: '按钮文案',
    buttonColor: '按钮颜色',
    clearBg: '清除背景图',
    designer: {
      selectNodeHint: '点击画布中的组件进行编辑，或切换「页面 / 搜索区 / 底部 Logo」配置固定组件',
      tabBusiness: '搜索区',
      dividerGradient: '渐变范围',
      previewNeedSave: '请先保存装修后再浏览',
      paletteTitle: '内容组件',
      paletteHint: '添加活动图片，可直接拖到画布中的签到区域上方或下方，添加后仍可拖动排序。',
      compImage: '图片',
      businessLocked: '搜索框、人员结果或定位表单属于业务组件，不可删除，只允许调整样式。',
      devicePhone: '手机',
      deviceWide: '宽屏手机',
      reset: '恢复默认',
      resetConfirm: '恢复默认会清空当前装修内容，是否继续？',
      save: '保存装修',
      preview: '浏览页面',
      propsTitle: '属性设置',
      propsHint: '页面设置始终生效；点击画布组件可编辑组件属性。',
      sectionPage: '页面',
      contentWidth: '内容宽度',
      paddingTop: '顶部间距',
      paddingSide: '左右边距',
      imageLimit: '支持 PNG、JPG、WEBP，最大 10MB',
      imageType: '图片仅支持 PNG、JPG 或 WEBP',
      imageTooLarge: '图片大小不能超过 10MB',
      bgSize: '背景填充',
      bgCover: '覆盖填满',
      bgContain: '完整显示',
      bgAuto: '原始尺寸',
      bgPosition: '背景定位',
      posCenterTop: '顶部居中',
      posLeftTop: '顶部居左',
      posRightTop: '顶部居右',
      posCenter: '页面居中',
      bgRepeat: '重复方式',
      repeatNo: '不重复',
      repeatYes: '平铺重复',
      sectionImage: '选中组件 · 图片',
      position: '显示位置',
      posBefore: '签到组件上方',
      posAfter: '签到组件下方',
      align: '对齐',
      alignLeft: '左对齐',
      alignCenter: '居中',
      alignRight: '右对齐',
      widthPct: '宽度 %',
      radius: '圆角',
      marginTop: '上方间距（px）',
      marginBottom: '下方间距（px）',
      clickToEdit: '点击画布中的内容组件进行编辑。固定业务组件样式请在下方设置。',
      sectionPanel: '业务区域',
      padding: '内边距',
      shadow: '显示阴影',
      sectionInput: '输入框',
      inputHint: '颜色使用系统默认值，仅开放尺寸设置。',
      height: '高度',
      fontSize: '字号',
      sectionButton: '签到按钮',
      textColor: '文字色',
      uploadHint: '点击组件后在右侧上传图片',
      dropBefore: '拖拽到这里，显示在签到组件上方',
      dropAfter: '拖拽到这里，显示在签到组件下方'
    }
  },
  checkinConfig: {
    tabCheckinMethod: '签到方式配置',
    tabDeviceCfg: '会议签到设备配置',
    tabCheckinRecord: '签到记录',
    tabCheckinPage: '签到页面配置',
    tabCheckinScreen: '签到屏配置',
    tabBadge: '参会配置',
    tabDataPlatform: '数据中台',
    tabDeviceMgmt: '设备管理',
    comingSoon: '{name} 建设中，敬请期待'
  },
  checkinMethod: {
    linkCheckin: '签到码链接',
    linkScreen: '人脸签到屏链接',
    linkActivity: '所属活动',
    linkSession: '本场会议',
    linkTime: '会议时间',
    linkVenue: '会议地点',
    linkPreview: '页面预览 ↗',
    copyLink: '复制链接',
    linkCopied: '签到链接已复制',
    typeTitle: '签到方式类型',
    allUnified: '所有会议统一配置',
    eachSeparate: '各会议分别配置',
    effective: '当前类型已生效',
    pendingApply: '类型待应用',
    saveAndApply: '保存并应用',
    unifiedTitle: '统一签到方式配置',
    unifiedDesc: '统一签到方式与相对时间规则；各会议保留独立签到记录、二维码和座位信息。',
    sessionDesc: '该会议独立配置签到方式',
    savedConfig: '已保存配置',
    unconfigured: '未配置',
    saveDisabledTip: '请先在顶部保存并应用类型',
    facePending: '待配置人脸识别设备',
    pendingSave: '待保存',
    collapse: '收起',
    expand: '展开',
    saveConfig: '保存配置',
    methodConfigTitle: '签到方式配置',
    meetingOption1: '2026-06-24 09:00-11:30 · "缘来是你"2026潮趣单身青年联谊派对活动开幕式暨主旨演讲',
    meetingOption2: '2026-06-24 14:00-15:30 · "缘来是你"2026潮趣单身青年联谊派对活动下午分论坛',
    meetingOption3: '2026-06-24 19:00-21:00 · "缘来是你"2026潮趣单身青年联谊派对颁奖晚宴',
    initHint: '初始配置参考："缘来是你"2026潮趣单身青年联谊派对活动开幕式暨主旨演讲；保存后应用于所有会议。',
    qrcodeTitle: '扫码签到',
    closed: '已关闭',
    enabled: '已开启',
    qrcodeDesc: '出示会场专属签到码，由工作人员或设备扫码完成签到',
    codeType: '码类型',
    dynamicCode: '动态码',
    staticCode: '静态码',
    qrcodeNote: '参会者使用微信扫一扫完成签到',
    deviceBoundPrefix: '已绑定',
    scanDeviceBoundSuffix: '台扫码签到设备',
    faceDeviceBoundSuffix: '台人脸识别设备',
    scanDeviceModalTitle: '扫码签到设备',
    allMeetingsUnified: '所有会议统一配置',
    unset: '未设置',
    editDeployment: '编辑部署位置',
    endedUse: '已结束使用',
    reuse: '再次使用',
    deviceEndedHint: '已结束使用，请在设备列表中点击再次使用',
    faceTitle: '人脸识别签到',
    faceDesc: '参会者通过人脸识别设备核验身份，完成快速签到',
    verifyDevice: '核验设备',
    deviceTip: '在「会议签到设备配置」中选择并连接人脸识别设备。',
    configDevice: '配置设备',
    warn1: '"缘来是你"2026潮趣单身青年联谊派对活动开幕式暨主旨演讲：待配置人脸识别设备',
    warn2: '"缘来是你"2026潮趣单身青年联谊派对活动下午分论坛：待配置人脸识别设备',
    warn3: '"缘来是你"2026潮趣单身青年联谊派对颁奖晚宴：待配置人脸识别设备',
    meetingTitle: '会场签到码',
    meetingDesc: '参会者扫描现场签到二维码，自助完成签到打卡',
    validity: '有效期',
    minutes: '分钟',
    scanValidityNote: '个人动态码有效时长',
    meetingNote: '超时需重新生成',
    locateTitle: '定位签到',
    locateDesc: '参会者在会场指定地理范围内打卡，系统自动校验位置',
    allowRange: '允许范围',
    meters: '米',
    rangeTip: '超出范围无法签到',
    checkinPeriod: '签到时段',
    periodTip: '按本场会议的签到开放、关闭时间执行，定位地点读取活动详情地址。',
    ruleTitle: '签到规则设置',
    openTime: '签到开放时间',
    closeTime: '签到关闭时间',
    open30m: '会议开始前 30 分钟',
    open1h: '会议开始前 1 小时',
    open2h: '会议开始前 2 小时',
    close15m: '会议开始后 15 分钟',
    close30m: '会议开始后 30 分钟',
    close1h: '会议开始后 1 小时',
    closeNone: '不限制'
  },
  checkinDevice: {
    pageTitle: '会议签到设备配置',
    pageDesc: '可统一配置全部会议的设备，也可按会议分别配置。',
    typeTitle: '签到设备配置类型',
    defaultConfig: '当前采用默认配置',
    transferReserve: '设备转场预留',
    transferHint: '按签到开放、关闭时间检查排期；再次使用时，在弹窗中选择具体会议并确认连接。',
    unifiedTitle: '统一签到设备配置',
    unifiedDesc: '共用同一套设备，各会议分别确认部署位置。',
    meetingDesc: '该会议独立配置签到设备',
    configDevice: '配置签到设备',
    statMeetings: '适用会议',
    statExpectedAttendees: '预计报名人数',
    statConfigured: '配置设备',
    statConnecting: '连接中',
    statOnline: '在线设备',
    statOffline: '离线设备',
    unitSession: '场',
    unitPerson: '人',
    unitDevice: '台',
    empty: '尚未配置设备，请点击「配置签到设备」添加。',
    modalTitle: '配置签到设备',
    modalTitleUnified: '配置统一签到设备',
    modalHint: '使用中的设备不可选择；选择可用设备后，可填写部署位置，也可先保存、稍后补充。',
    pickerPlaceholder: '请选择配置的设备',
    deployTip: '选择设备后可填写部署位置，也可稍后补充。',
    deployPlaceholder: '选填，可稍后补充',
    optional: '（选填）',
    connectSave: '连接并保存配置',
    deployMeeting1: '2026-06-24 09:00-11:30 · 天河体育馆 A 区',
    deployMeeting2: '2026-06-24 14:00-15:30 · 天河体育馆 B 区',
    deployMeeting3: '2026-06-24 19:00-21:00 · 天河体育馆 VIP 区',
    statusOnline: '在线',
    statusOffline: '离线',
    devGateW01Name: '人脸识别闸机 #1',
    devGateW01Desc: 'GATE-W01 · 人脸识别闸机',
    devGateE01Name: '人脸识别闸机 #2',
    devGateE01Desc: 'GATE-E01 · 人脸识别闸机',
    devQrMainName: '主签到大屏签到码',
    devQrMainDesc: 'QR-MAIN01 · 签到码终端',
    devScanA01Name: '分会场扫码枪 #1',
    devScanA01Desc: 'SCAN-A01 · 扫码签到设备',
    devScanA02Name: '分会场扫码枪 #2',
    devScanA02Desc: 'SCAN-A02 · 扫码签到设备',
    devLocBs01Name: '定位签到基站',
    devLocBs01Desc: 'LOC-BS01 · 定位签到设备',
    devPrintA1Name: '制证机 #A1',
    devPrintA1Desc: 'PRINT-A1 · 工作证制证机',
    devPrintA2Name: '制证机 #A2',
    devPrintA2Desc: 'PRINT-A2 · 工作证制证机',
    devPrintA3Name: '制证机 #A3',
    devPrintA3Desc: 'PRINT-A3 · 工作证制证机',
    devCamC01Name: '中央监控摄像头',
    devCamC01Desc: 'CAM-C01 · 监控摄像头'
  },
  checkinRecord: {
    pageTitle: '签到记录',
    pageDesc: '查看参会人签到状态、签到方式和工作证打印情况，并支持数据导出。',
    filterSession: '全部会议场次',
    filterStatus: '全部状态',
    filterMethod: '全部签到方式',
    searchPlaceholder: '搜索姓名/单位',
    export: '导出签到表',
    statTotal: '应签到人次',
    statSigned: '已签到人次',
    statPending: '未签到人次',
    statRate: '签到率',
    colNo: '序号',
    colCheckinNo: '签到编号',
    colName: '姓名',
    colOrg: '单位 / 社团',
    colSession: '会议场次',
    colMethod: '签到方式',
    colStatus: '签到状态',
    colPrint: '工作证打印状态',
    colTime: '签到时间',
    colActions: '操作',
    statusSigned: '已签到',
    statusPending: '未签到',
    printDone: '已打印',
    printUndone: '未打印',
    printPrinting: '打印中',
    methodScan: '扫码签到',
    methodCode: '会场签到码',
    methodLocate: '定位签到',
    methodFace: '人脸识别',
    methodManual: '人工补签',
    detail: '详情',
    makeup: '补签',
    makeupTitle: '确认补签',
    makeupConfirm: '确认签到',
    makeupCancel: '取消',
    makeupHint: '确认补签后，系统将记录当前时间为该参会人在此会议场次的签到时间，状态变更为「已签到」。',
    makeupSuccess: '补签成功',
    detailTitle: '参会人签到详情',
    detailPhone: '手机号',
    detailEmail: '邮箱',
    detailJobTitle: '职位',
    detailSource: '人员来源',
    detailSeat: '座位号',
    detailPolicy: '参与策略',
    detailClose: '关闭',
    empty: '暂无签到记录'
  },
  checkinPage: {
    typeTitle: '签到页面配置类型',
    allUnified: '所有会议统一配置',
    eachSeparate: '各会议分别配置',
    applied: '当前类型已应用',
    modeChangeTitle: '变更签到页面配置类型',
    modeChangeCurrent: '当前已选择',
    modeChangeAsk: '，是否变更为',
    modeChangeEnd: '？',
    modeChangeHint: '确认后立即应用对应类型已保存的页面方案；两种类型的配置和未保存的编辑均会保留。',
    modeChangeCancel: '取消',
    modeChangeConfirm: '确认变更',
    modeChangeClose: '关闭页面类型变更确认',
    unifiedTitle: '统一签到信息配置',
    unifiedDesc: '适用于全部 3 场会议',
    sessionDesc: '该会议独立配置签到页面',
    savedConfig: '已保存配置',
    pendingSave: '待保存',
    saveConfig: '保存配置',
    collapse: '收起',
    expand: '展开',
    entryTitle: '签到入口',
    mobilePage: '手机签到页',
    pageTitle: '页面标题',
    guideMessage: '引导文案',
    facePage: '人脸识别签到屏',
    faceWaitTitle: '等待识别标题',
    faceWaitMessage: '等待识别提示',
    successTitle: '签到成功后展示',
    successDesc: '设置签到成功后的展示信息及显示终端',
    successNavTitle: '签到结果',
    successNavBadge: 'CHECK-IN',
    successEyebrow: 'CHECK-IN COMPLETE',
    successConfirmed: '已完成本场签到',
    successMeetingLabel: '本场会议',
    successSeatLabel: '会议席位',
    successCheckinTime: '2026-06-24 08:42:13',
    successCheckinMethod: '人脸识别',
    successMethodLine: '签到方式：人脸识别',
    successPrintingTitle: '正在演示证件打印...',
    successPrintingMessage: '证件正在生成，请稍候领取。',
    successPrintTitle: '证件已出证，请领取',
    successPrintBadge: '打印演示',
    successPrintMessage: '证件已出证，请前往现场证件打印区领取（演示）。',
    successAttendeeTitle: '参会信息',
    successUnfilled: '未填写',
    successExtend: '延长查看时间',
    successFinish: '完成，返回签到',
    successCountdown: '为保护您的信息，{seconds} 秒后返回签到页',
    successFooter: '祝您参会愉快',
    successPageTitle: '成功页标题',
    successMessage: '成功提示文案',
    pcSuccessTitle: '人脸签到屏成功标题',
    pcSuccessMessage: '人脸签到屏成功提示',
    enable: '启用',
    moveUp: '上移',
    moveDown: '下移',
    remove: '删除',
    moduleTitle: '模块标题',
    displayFields: '展示字段',
    fieldName: '姓名',
    fieldOrg: '单位',
    fieldPosition: '职务',
    fieldPhone: '手机',
    fieldEmail: '邮箱',
    fieldVenue: '座位场地',
    fieldArea: '区域',
    fieldSeat: '座位号',
    seatFieldsLabel: '展示字段（自动读取本人在本场会议的座位）',
    showOnMobile: '在手机签到页展示',
    showOnFace: '在人脸识别签到屏展示',
    showSeatMap: '展示座位指引图',
    seatMapLabel: '自定义座位指引图（选填，PNG / JPG / WebP，最大 1 MB）',
    seatMapHint: '未上传时自动读取本场座位布局，并标记本人座位；上传后优先展示该图片。',
    seatMapCaption: '座位指引图',
    seatMapStage: '舞台 / 屏幕',
    seatMapPin: '您的座位',
    seatMapZoom: '点击放大查看',
    chooseImage: '选择图片',
    replaceImage: '更换图片',
    removeImage: '移除图片',
    seatMapUploadTip: 'PNG / JPG / WebP，最大 1 MB',
    seatMapTooLarge: '图片不能超过 1 MB',
    seatMapTypeError: '请上传 PNG / JPG / WebP 图片',
    emptyMode: '未安排座位时',
    emptyModeMessage: '显示提示',
    emptyModeHide: '隐藏座位模块',
    emptyText: '无座位提示',
    addModule: '添加展示内容',
    moduleProfile: '个人信息',
    moduleSeat: '本场座位',
    moduleContact: '会务客服',
    moduleCustom: '自定义内容',
    modulesEmpty: '暂无展示内容，请从下方添加',
    contactName: '联系人 / 服务名称',
    contactPhone: '联系电话',
    contactNote: '服务说明',
    contactLink: '客服链接（选填）',
    contactButtonLabel: '链接按钮文字',
    contactQrLabel: '微信二维码（选填，PNG / JPG / WebP，最大 1 MB）',
    customContent: '内容',
    customLink: '跳转链接（选填）',
    customButtonLabel: '按钮文字',
    previewTitle: '页面效果预览',
    previewMobile: '手机签到页',
    previewSuccess: '签到成功页',
    previewPc: '人脸识别签到屏',
    previewPerson: '预览人员',
    previewBack: '返回',
    personAttendee: '本场参会人',
    openPreview: '打开手机页预览',
    openSuccessPreview: '打开签到成功页预览',
    openFacePreview: '打开人脸识别屏预览',
    previewHint: '点击后在新窗口打开对应签到页面。',
    previewToast: '浏览器拦截了预览窗口，请允许弹出窗口后重试',
    checkedIn: '已完成',
    checkinTime: '签到时间',
    checkinMethod: '签到方式',
    noSeat: '座位暂未安排，请联系会务组。',
    noModules: '暂无展示内容',
    waitingFace: '等待识别',
    faceSuccess: '识别成功',
    faceScreenTitle: '人脸识别签到屏',
    faceConferenceName: '2026大湾区青年社团高峰论坛',
    faceStepsLabel: '签到步骤',
    faceStepFace: '人脸识别',
    faceStepConfirm: '签到确认',
    faceStepSchedule: '查看参会安排',
    faceEyebrow: 'FACE CHECK-IN',
    faceStatusWaiting: '等待签到结果',
    faceStatusScanning: '正在扫描人脸...',
    faceStatusConfirming: '识别通过，正在确认签到...',
    faceInstructionFace: '① 正面面向摄像头',
    faceInstructionClear: '② 保持面部无遮挡',
    faceInstructionWait: '③ 等待识别确认',
    faceDemoTip: '点击模拟有人靠近签到',
    faceBackTip: '再次点击返回等待识别',
    faceFooterBrand: '半度云 · 智能会务系统',
    otherMethods: '其他签到方式',
    myCode: '我的签到码',
    showCode: '出示给工作人员',
    immediately: '立即签到',
    notLocated: '本场会议未开启定位签到',
    footer: '半度云智能会务系统 · 签到',
    eventTitle: '"缘来是你"2026潮趣单身青年联谊派对活动开幕式暨主旨演讲',
    eventTime: '2026-06-24 09:00-11:30',
    venue: '天河体育馆 A区',
    defaultEntryTitle: '活动签到',
    defaultGuide: '请选择下方签到方式完成入场',
    defaultFaceWaitTitle: '欢迎您，请面向签到设备',
    defaultFaceWaitMessage: '识别成功后，即可查看您的专属参会安排',
    defaultSuccessTitle: '签到成功',
    defaultSuccessMessage: '欢迎参加本场会议，请查看您的参会安排。',
    defaultProfileTitle: '个人信息',
    defaultSeatTitle: '本场座位',
    defaultContactTitle: '会务客服',
    defaultCustomTitle: '自定义内容',
    defaultContactName: '会务组',
    defaultContactPhone: '400-888-8888',
    defaultContactNote: '如有疑问，请联系会务组。',
    defaultContactButton: '联系客服',
    defaultCustomContent: '欢迎参加本次会议，祝您参会愉快。',
    defaultCustomButton: '查看详情',
    defaultEmptyText: '座位暂未安排，请联系会务组。'
  },
  checkinScreen: {
    title: '人脸识别签到屏配置',
    desc: '当前活动的人脸识别PC签到屏',
    scanPanelTitle: '签到码页面装修',
    scanPanelDesc: '当前活动的现场扫码签到页面',
    pendingSave: '有更改待保存',
    saved: '已保存',
    collapse: '收起',
    expand: '展开',
    save: '保存装修',
    savedToast: '签到屏配置已保存',
    visualTitle: '页面视觉装修',
    adaptive: '自适应屏幕',
    adaptiveHint: '开启后随屏幕尺寸调整布局；关闭后以 16:9 画面等比显示。',
    conferenceNameZh: '大会中文名称',
    conferenceNameZhPlaceholder: '留空时使用活动名称',
    conferenceNameEn: '大会英文名称',
    conferenceNameEnPlaceholder: '请输入大会英文名称（选填）',
    accent: '主题色',
    titleSize: '标题字号',
    align: '标题对齐',
    alignLeft: '居左',
    alignCenter: '居中',
    radius: '内容样式',
    radiusRound: '圆角',
    radiusSquare: '直角',
    backgroundImage: '页面背景图',
    logo: '页面Logo',
    remove: '移除',
    upload: '上传图片',
    uploadTip: 'PNG / JPG / WebP，最大 1 MB',
    uploadTypeError: '请上传 PNG / JPG / WebP 图片',
    uploadTooLarge: '图片不能超过 1 MB',
    uploadFailed: '图片读取失败，请重试',
    backgroundPreviewAlt: '页面背景图预览',
    logoPreviewAlt: '页面Logo预览',
    uploadBackground: '上传页面背景图',
    uploadLogo: '上传页面Logo',
    note: '入口文案和签到成功后的内容，可在顶部「签到页面配置」中设置。',
    canvasTitle: '装修效果画布',
    previewSwitchLabel: '选择预览页面',
    previewFace: '人脸识别签到屏',
    previewScan: '签到码页面',
    scanTitle: '扫码标题',
    scanMessage: '扫码提示',
    scanTitleDefault: '欢迎参加，请扫码签到',
    scanMessageDefault: '使用微信扫一扫，进入本场签到页',
    openPreview: '打开PC签到屏预览',
    openScanPreview: '打开签到码页面预览',
    previewHint: '点击后在新窗口打开对应签到页面。',
    previewWindowTitle: '人脸识别签到屏预览',
    previewScanWindowTitle: '签到码页面预览',
    popupBlocked: '浏览器拦截了新窗口，请允许弹出窗口后重试'
  },
  checkinBadge: {
    modeTitle: '参会配置类型',
    modeUnified: '所有会议统一配置',
    modeDifferent: '各会议分别配置',
    applied: '当前类型已应用',
    modeChangeTitle: '变更参会配置类型',
    modeChangeCurrent: '当前已选择',
    modeChangeAsk: '，是否变更为',
    modeChangeEnd: '？',
    modeChangeHint: '确认后立即切换配置类型；两种类型的配置和未保存的编辑均会保留。',
    modeChangeCancel: '取消',
    modeChangeConfirm: '确认变更',
    modeChangeClose: '关闭配置类型变更确认',
    tabConfig: '证件配置',
    tabRecords: '打印记录',
    backToConfig: '返回参会配置',
    unifiedTitle: '统一参会配置',
    unifiedDesc: '适用于全部 3 场会议',
    meetingPanelTitle: '{name} · 参会配置',
    meetingDesc: '该会议独立配置参会证件',
    meetingShort1: '开幕式暨主旨演讲',
    meetingShort2: '下午分论坛',
    meetingShort3: '颁奖晚宴',
    notConfigured: '未配置',
    pendingSave: '有更改待保存',
    savedAt: '已保存 · {time}',
    collapse: '收起',
    expand: '展开',
    saveUnified: '保存统一配置',
    saveMeeting: '保存配置',
    savedToast: '参会配置已保存',
    styleTitle: '证件样式配置',
    defaultTitle: '参会证',
    name: '证件名称',
    size: '证件尺寸',
    sizePortrait: '竖版 · 90 × 130 mm',
    sizeLandscape: '横版 · 86 × 54 mm',
    background: '证件背景图片（选填）',
    presetBlue: '蓝色光轨',
    presetSilver: '银白电路',
    presetCyan: '青蓝网格',
    presetAria: '{name}背景',
    customReady: '已上传自定义背景，可更换或移除',
    customPreviewAlt: '自定义证件背景预览',
    uploadTip: 'PNG / JPG / WebP，最大 1 MB',
    uploadBackground: '上传背景',
    replaceBackground: '更换背景',
    removeBackground: '移除背景',
    uploadTypeError: '请上传 PNG / JPG / WebP 图片',
    uploadTooLarge: '图片不能超过 1 MB',
    uploadFailed: '图片读取失败，请重试',
    color: '文字颜色',
    template: '打印样式',
    templateFull: '背景和参会信息',
    templateBg: '仅背景',
    fields: '展示信息',
    fieldName: '姓名',
    fieldOrg: '单位 / 社团',
    fieldPosition: '职务',
    fieldSeat: '座位号',
    fieldMeeting: '会议名称',
    autoPrint: '签到成功后自动打印',
    autoPrintHint: '四种签到方式共用本场配置；每位参会人首次出证，重复签到不会再次打印。',
    printer: '打印设备',
    colPrinter: '设备信息',
    colLocation: '设备部署位置',
    colStatus: '连接状态',
    colActions: '操作',
    printerName: '制证机 #A1',
    printerCode: 'PRINT-A1',
    printerModel: '工作证制证机',
    currentService: '当前服务：{name}',
    online: '在线',
    offline: '离线',
    notSet: '未设置',
    defaultLocation1: '天河体育馆 A 区',
    defaultLocation2: '天河体育馆 B 区',
    defaultLocation3: '天河体育馆 VIP 区',
    editLocation: '编辑部署位置',
    endUse: '结束使用',
    printerEmpty: '尚未配置打印设备，配置后可在签到成功时自动出证。',
    configPrinter: '配置打印设备',
    endConfirmTitle: '结束使用',
    endConfirmMessage: '结束后将清除该打印设备的部署位置，确定结束使用吗？',
    endConfirm: '结束使用',
    endToast: '已结束该打印设备的使用',
    modalTitle: '编辑打印设备部署位置',
    modalHint: '请填写该设备在各会议场地的部署位置；也可先保存，稍后补充。',
    locationPlaceholder: '选填，如：天河体育馆 A 区',
    modalSave: '保存部署位置',
    locationSaved: '打印设备部署位置已保存',
    preview: '证件预览',
    previewPerson: '预览人员',
    previewHint: '预览使用本场参会信息，打印时使用已保存的配置。',
    onlyBackground: '仅背景',
    printBadge: '打印证件',
    printedToast: '已记录本次打印，可在「打印记录」中查看',
    certOrg: '单位',
    certPosition: '职务',
    certSeat: '座位',
    certMeeting: '会议',
    recordsTitle: '打印记录',
    recordsDesc: '本场会议的首次打印、补打及已有打印状态',
    selectMeeting: '选择会议',
    searchPlaceholder: '搜索姓名 / 单位',
    filterAll: '全部打印类型',
    filterFirst: '首次打印',
    filterReprint: '补打',
    filterExisting: '已有打印',
    count: '共 {n} 条',
    recordsEmpty: '暂无打印记录',
    colTime: '打印时间',
    colName: '姓名',
    colOrg: '单位 / 社团',
    colBadge: '证件名称',
    colKind: '打印类型',
    colDevice: '打印设备',
    colCopies: '份数',
    colResult: '结果',
    colSource: '来源',
    kindFirst: '首次打印',
    kindReprint: '补打',
    kindExisting: '已有打印',
    resultDone: '打印完成',
    resultPrinted: '已打印',
    sourceConfig: '参会配置',
    sourceExisting: '已有打印状态',
    timeUnrecorded: '时间未记录',
    copies: '{n} 份'
  },
  checkinDashboard: {
    fullscreen: '标签页全屏',
    exitFullscreen: '退出全屏',
    fullscreenFailed: '当前浏览器不支持全屏预览',
    copyLink: '复制分享链接',
    linkCopied: '分享链接已复制到剪贴板',
    linkCopyFailed: '复制失败，请手动复制浏览器地址栏链接',
    titleSuffix: '数据中台',
    devices: '硬件设备',
    badgeBoard: '工作证打印看板',
    badgeTotal: '应制证',
    quickPrint: '一键补打',
    printAll: '一键补打全部未打印',
    printRate: '制证完成率 {rate}%',
    printQueue: '待打印队列 {count}',
    noBadgeMachine: '本场未配置制证机',
    noBadgeRecords: '本场暂无制证记录',
    allBadgesDone: '全部工作证已完成制证 ✅',
    pendingNames: '待打印：{names}',
    printSent: '已向制证机发送批量补打任务：{count} 张',
    printSentOne: '已向制证机发送工作证补打任务：{name}',
    noPendingBadge: '当前没有待补打的工作证',
    wayRatio: '签到方式占比',
    realtime: '实时统计',
    signInRate: '签到率',
    signedOfTotal: '已签到 {done} / 应到 {total}',
    peopleCount: '{count} 人',
    alarmCenter: '异常告警中心',
    resolveAll: '全部处理',
    resolveAllCount: '全部处理（{count}）',
    resolve: '处理',
    noAlarms: '当前无待处理告警',
    alarmPending: '待签到',
    alarmSuffix: '尚未完成本场会议签到',
    alarmResolved: '该告警已处理归档',
    alarmsCleared: '已批量处理 {count} 条告警',
    rankTitle: '单位到勤排行榜',
    rankTip: 'TOP {count} · 总体到勤率 {rate}%',
    rankAttend: '实到 {done} / 应到 {total} 人',
    rankEmpty: '本场暂无单位签到数据',
    cameraTitle: '智能闸机实时监控',
    cameraNoDevice: '本场未配置监控设备',
    faceZone: '智能识别比对区',
    passCount: '当前通过人数：',
    viewAll: '查看全部数据',
    preRecorded: '预录入人脸',
    liveCapture: '现场抓拍',
    faceEmpty: '本场暂无人脸识别签到记录',
    facePass: '已通过',
    faceFail: '未通过',
    latestRecords: '最新签到记录',
    colBadge: '工作证',
    colStatus: '状态',
    colTime: '时间',
    reprint: '补充打印',
    viewDetail: '查看详情',
    close: '关闭',
    tableEmpty: '未找到匹配的签到记录',
    tableEmptyAll: '本场暂无签到记录',
    personDetail: '人员详情',
    profile: '个人资料',
    role: '职务',
    phone: '联系电话',
    seatInfo: '参会座位',
    zone: '区域',
    seatNo: '座位号',
    hotelInfo: '酒店信息',
    hotelName: '酒店名称',
    roomType: '房型',
    roomNo: '房间号',
    faceModalTitle: '全部人脸签到信息',
    colRemark: '备注',
    deviceModalTitle: '硬件设备监控',
    deviceSummary: '本场活动共接入 {total} 台设备 · 在线 {online} 台',
    deviceEmpty: '本场活动暂未接入硬件设备',
    deviceOnline: '在线',
    deviceOffline: '离线',
    deviceLast: '最后通信：{time}',
    devicePass: '累计通行：{count} 人次',
    printSuccessTitle: '工作证补打成功',
    printSuccessDesc: '已为 {name} 重新制证并打印，请前往制证机领取。',
    gotIt: '我知道了'
  },
  checkinDeviceMgmt: {
    pageTitle: '设备管理',
    pageDesc: '管理本活动接入的签到设备，查看在线状态与识别情况。',
    addDevice: '添加设备',
    allTypes: '全部设备分类',
    typeOption: '{label}（{count}）',
    searchPlaceholder: '搜索设备名称 / 编号 / 类型',
    colName: '设备名称',
    colCode: '设备编号',
    colType: '设备分类',
    colOps: '操作',
    detail: '详情',
    viewRecords: '查看记录',
    empty: '没有匹配的设备',
    emptyHint: '试试更换设备分类或搜索关键词',
    typeGate: '人脸识别闸机',
    typeQr: '签到码终端',
    typeScan: '扫码签到设备',
    typeLocate: '定位签到设备',
    typePrint: '工作证制证机',
    typeCamera: '监控摄像头',
    bindTitle: '添加设备',
    bindCode: '设备编号',
    bindCodePlaceholder: '如 GATE-W02',
    bindName: '设备名称',
    bindNamePlaceholder: '如 人脸识别闸机 #3',
    bindType: '设备类型',
    bindHint: '点击「确认绑定」后，系统将自动搜索设备，并完成安全连接、设备证书校验与签到配置同步。',
    bindCodeRequired: '请填写设备编号',
    bindNameRequired: '请填写设备名称',
    bindCodeExists: '该设备编号已存在，请更换后重试',
    bindSuccess: '已添加设备：{name}',
    cancel: '取消',
    confirmBind: '确认绑定',
    close: '关闭',
    detailTitle: '设备详情 · {name}',
    recentUse: '最近使用',
    recentSession: '最近使用会议日程',
    noSession: '暂无会议使用记录',
    location: '部署位置',
    locationPending: '待配置部署位置',
    runningData: '运行数据',
    totalPass: '累计通行',
    todayPass: '今日通行',
    totalPrint: '累计制证',
    todayPrint: '今日制证',
    totalCamera: '累计抓拍',
    todayCamera: '今日抓拍',
    onlineDuration: '在线时长',
    lastComm: '最后通信',
    firmwareShort: '固件',
    ipShort: 'IP',
    boundAtShort: '绑定于',
    lastSeen: '最近一次',
    durationMin: '{m} 分钟',
    durationHour: '{h} 小时',
    durationHM: '{h} 小时 {m} 分',
    peopleUnit: '人次',
    justConnected: '刚刚接入',
    deviceInfo: '设备信息',
    firmware: '固件版本',
    ipAddress: '局域网地址',
    ipPending: '待分配',
    boundAt: '绑定时间',
    rateGate: '识别成功率',
    rateQr: '扫码成功率',
    rateScan: '扫码成功率',
    rateLocate: '上报成功率',
    ratePrint: '打印成功率',
    rateCamera: '在线可用率',
    recordsTitle: '设备使用记录 · {name}',
    recordsMeta: '设备编号：{code} · {type}',
    selectSession: '选择会议日程',
    recordsCount: '本机设备使用记录（{count}）',
    recordsEmpty: '该会议暂无此设备的使用记录',
    colTime: '时间',
    colPerson: '参会人',
    colOrg: '单位 / 社团',
    colResult: '结果',
    resultSuccess: '成功',
    resultFailed: '失败'
  },
  seating: {
    pageTitle: '座位分配记录',
    tabQueryPages: '页面编辑',
    tabRecords: '座位表',
    add: '新增',
    import: '导入',
    export: '导出',
    exportTemplate: '导出模板',
    adjust: '调整座位',
    empty: '暂无座位分配记录',
    filterMeeting: '全部会议场次',
    filterKeyword: '搜索姓名 / 座位号',
    colId: 'ID',
    colSeatNo: '座位号',
    colName: '姓名',
    colPhone: '手机号',
    colSeatType: '座位类型',
    colSession: '所属场次',
    colRow: '行号',
    colCol: '列号',
    colRemark: '备注',
    typeNormal: '普通座位',
    typeVip: '贵宾座位',
    formTitleAdd: '新增座位',
    formTitleEdit: '调整座位',
    phName: '请输入姓名',
    phPhone: '请输入手机号',
    phSeatNo: '请输入座位号',
    phSession: '请选择场次',
    phRemark: '选填',
    seatNoRequired: '请填写座位号',
    meetingRequired: '请选择所属场次',
    createSuccess: '座位已新增',
    updateSuccess: '座位已更新',
    deleteSuccess: '座位已删除',
    deleteConfirm: '确定删除座位 {seatNo} 吗？',
    importTip: 'Excel 列：ID、座位号、姓名、手机号、座位类型、所属场次（会议日程 ID，选填）、行号、列号、备注。ID 存在则更新，不存在则新增。所属场次可留空。请先下载模板。单次最多 1000 行。',
    importDrop: '拖拽 Excel 到此处，或点击上传（.xlsx / .xls）',
    importTypeError: '请上传 .xlsx 或 .xls 文件',
    importEmpty: '没有可导入的数据行',
    importParseFailed: '解析 Excel 失败',
    importReady: '已解析 {n} 行，确认后写入',
    importDone: '导入完成：新增 {created}，更新 {updated}，失败 {failed}',
    importRowFail: '第 {row} 行：{message}',
    enterEditor: '进入座位编辑器',
    queryList: {
      pageTitle: '座位查询页',
      add: '新增查询页',
      empty: '暂无座位查询页',
      filterName: '搜索名称',
      meetingNone: '无场次',
      colName: '名称',
      colActivity: '所属活动',
      colSession: '会议日程',
      colPageUrl: '页面分享',
      pageUrlBtn: '浏览',
      editBtn: '页面装修',
      shareTitle: '页面地址',
      shareTip: '扫描二维码或复制下方链接打开查询页',
      copyLink: '复制',
      copySuccess: '链接已复制',
      copyFailed: '复制失败，请手动复制'
    },
    queryEditor: {
      pageSelectPlaceholder: '选择历史页面',
      pageNew: '新建查询页',
      pageNamePlaceholder: '查询座位 + 随机编号',
      dragToDelete: '拖动到此处删除',
      deviceNormal: '普通手机',
      deviceWide: '宽屏手机',
      browse: '浏览',
      paletteTitle: '组件库',
      groupBasic: '基础组件',
      groupLayout: '布局组件',
      compText: '文本',
      compImage: '图片',
      compSeatMap: '座位图',
      compQueryBg: '查座位背景图',
      compSpacer: '空白',
      compDivider: '分割线',
      compFloatButton: '悬浮按钮',
      canvasTitle: '页面效果',
      dragSort: '拖动排序',
      propsTitle: '组件属性',
      selectNodeHint: '点击画布中的组件进行编辑，或切换「页面 / 查询器 / 提示区 / 底部 Logo」配置固定组件',
      showComponent: '显示',
      tabProps: '属性',
      tabPage: '页面',
      tabQuery: '查询器',
      tabHint: '提示区',
      tabLogo: '底部 Logo',
      fieldContent: '文本内容',
      fieldFontSize: '字号',
      fieldFontWeight: '粗细',
      fieldColor: '颜色',
      fieldAlign: '对齐',
      fieldWidth: '宽度（%）',
      fieldHeight: '高度（px）',
      fieldRadius: '圆角',
      fieldBgColor: '背景色',
      alignLeft: '左',
      alignCenter: '中',
      alignRight: '右',
      weightRegular: '常规',
      weightMedium: '中等',
      weightSemibold: '半粗',
      weightBold: '粗体',
      seatMapHint: '建议上传清晰的座位布局图，支持 JPG、PNG、GIF 格式。',
      queryBgHint: '独立图层，不包裹其他组件。点左侧蓝色手柄或组件库中的「查座位背景图」即可选中；查询框周围的空白处也可点到背景图。排在后面的组件会盖在背景图之上。',
      queryBgSingle: '查座位背景图只能添加一个',
      queryBgSelectHint: '已添加，点击选中',
      queryBgHandle: '选中背景图，拖动手柄调整叠放',
      fieldPosition: '位置',
      fieldOffsetY: '距顶（px）',
      fieldPaddingTop: '上内边距（px）',
      fieldPaddingBottom: '下内边距（px）',
      queryType: '查询类型',
      queryTypeName: '仅姓名',
      queryTypePhone: '仅手机号',
      queryTypeBoth: '姓名 + 手机号',
      matchMode: '匹配逻辑',
      matchExact: '精确匹配',
      matchFuzzy: '模糊匹配',
      inputWidth: '输入框长度（%）',
      inputRadius: '输入框圆角',
      queryAlign: '输入框位置',
      buttonPlacement: '按钮位置',
      buttonRow: '与输入框同一行',
      buttonBelow: '在输入框下方',
      buttonText: '按钮文字',
      buttonRadius: '按钮圆角',
      buttonBgColor: '按钮框体颜色',
      buttonFontSize: '按钮字号',
      buttonTextColor: '按钮文字颜色',
      successHint: '成功提示信息',
      replaceQueryOnSuccess: '替换查询器',
      replaceQueryOnSuccessHelp: '查询成功时会隐藏查询器，在原位置显示成功提示，可点返回继续查询',
      successHintHelp: '查询成功时显示的信息，{seat_number} 会被替换为实际座位号',
      backToQuery: '返回',
      seatNumberOwnLine: '座位号单行显示',
      showGuestName: '显示姓名',
      seatFontSize: '座位字号',
      errorHint: '错误提示信息',
      errorHintHelp: '查询失败时以浮标显示几秒，不占用页面位置',
      hintText: '文案',
      removeComponent: '删除组件',
      saveSuccess: '座位查询页已保存',
      nameDuplicate: '该名称已存在，请修改后再保存',
      saveFailed: '保存失败，请稍后重试',
      previewNeedSave: '请先保存后再浏览 H5 页面',
      resetConfirm: '重置将恢复默认查询页布局（未保存前不会写入数据库），确定继续？',
      resetDone: '已恢复默认布局，请保存后生效',
      switchUnsaved: '当前修改尚未保存，切换页面将丢弃未保存内容，是否继续？',
      switchTitle: '切换页面',
      h5NotFound: '座位查询页不存在或尚未保存',
      phName: '请输入姓名',
      phPhone: '请输入手机号',
      needName: '请输入姓名',
      needPhone: '请输入手机号',
      searchFailed: '查询失败，请稍后重试'
    }
  },
  eventTime: '活动时间',
  timeStartPlaceholder: '开始时间',
  timeEndPlaceholder: '结束时间',
  list: {
    welcomeTitle: 'Welcome!',
    welcomeSubtitle: '欢迎使用半度云智能会务系统',
    welcomePromoTitle: '照片直播 AI 修图功能重磅上新啦',
    welcomePromoDesc: 'AI 赋能极速精修，活动直播帧帧出片。',
    welcomeDocBtn: '查看使用文档',
    colIndex: '序号',
    colActivityInfo: '活动信息',
    colStatus: '活动状态',
    colActions: '操作',
    meetingSessions: '会议场次：{n} 场',
    statTotalActivities: '活动总数',
    statOngoingSub: '进行中 {n} 场',
    statTotalRegistrations: '累计报名人数',
    statTotalCheckins: '累计签到人次',
    statTotalIncome: '累计收益',
    statPageHint: '本页合计',
    unitPerson: '人',
    unitTimes: '次',
    unitWan: '万',
    quickEnterSettings: '进入设置',
    quickSchedule: '会议日程',
    quickRegRecords: '参与记录',
    quickSeating: '座位表',
    quickItinerary: '行程安排',
    quickCheckin: '签到管理',
    quickDecorate: '页面装修',
    quickMicrosite: '活动官网',
    quickAgenda: '会议议程',
    quickJoinReg: '参与报名',
    quickRegRecordsJoined: '报名记录',
    quickSeatingInfo: '座位信息',
    quickHotel: '酒店安排',
    quickOrders: '订单明细',
    tagJoined: '参与的活动',
    tagCreated: '创建的活动',
    filterAllOwnership: '全部的活动',
    filterJoined: '参与的活动',
    filterCreated: '创建的活动',
    inviterLabel: '邀请方：{name}',
    opViewDetail: '查看详情',
    createActivity: '创建活动',
    topForm: '问卷管理',
    topItinerary: '行程预设',
    topPayment: '支付管理',
    topAudit: '名单审核',
    topAssociation: '报名关联',
    allActivities: '所有活动({count})',
    advancedFilter: '高级筛选',
    searchNameOnly: '搜索活动名称',
    countdown: '倒计时',
    share: '分享',
    sort: '排序',
    qrShare: '二维码分享',
    addressUnset: '暂未设置地点',
    statusUnset: '—',
    statusEnded: '已结束',
    statusOngoing: '进行中',
    countdownDays: '{days}天',
    opActivity: '活动',
    opSchedule: '日程',
    opShare: '分享',
    opDecorate: '装修',
    opPayment: '支付',
    opRegistration: '报名',
    opCheckin: '签到',
    opSeating: '座位',
    opDelete: '删除',
    statusAutoTip: '活动状态由系统根据开始/结束时间自动判定：进行中 · 已结束 · 倒计时。',
    statAll: '全部活动',
    statOngoing: '进行中',
    statEnded: '已结束',
    statUnset: '未设置时间',
    filterAllStatus: '全部状态',
    filterOngoing: '进行中',
    filterEnded: '已结束',
    filterUnset: '未设置',
    unitEvent: '场'
  },
  /** 受邀参与的活动工作台 */
  invited: {
    navGroup: '受邀参与的活动',
    navIntro: '活动官网',
    navAgenda: '会议议程',
    navRegistration: '参与报名',
    navOrders: '订单明细',
    introTitle: '活动官网',
    agendaTitle: '活动日程详情',
    regTitle: '参与报名',
    ordersTitle: '活动订单',
    openHome: '新窗口打开',
    phonePreviewTitle: '活动微站首页预览',
    phoneHint: '预览为活动微站首页，可在手机框内滚动浏览',
    noHomePage: '该活动尚未设置微站首页',
    loadHomeFailed: '加载微站首页失败',
    invalidActivity: '无效的活动 ID',
    labelTime: '举办时间',
    labelVenue: '举办地点',
    labelInviter: '主办方 / 邀请方',
    sectionIntro: '活动简介',
    sectionHighlights: '议程亮点',
    contactLabel: '本次活动对接人',
    goRegister: '前往报名'
  },
  /** 酒店库（独立配置，mock；后续对接 API） */
  hotel: {
    listTitle: '酒店列表',
    addHotel: '新增酒店',
    bannerTitle: '这里是酒店库 — 统一管理所有可用酒店',
    bannerHtml: '📋 在此维护平台可用的酒店基础信息，包括酒店名称、地址、设施、套餐模板与门头图片等。<br>🔗 <b>酒店库与活动是分离的</b>：酒店信息在此统一录入和维护，各活动在「活动配置 → 酒店配置」中按需关联本库中的酒店，并可为每场活动单独设置价格与可用房间数。<br>💡 建议先在此处完善酒店信息（含套餐与图片），再前往各活动进行关联配置。',
    empty: '暂无酒店，请点击右上角新增',
    editDetail: '编辑详情',
    backToList: '返回酒店列表',
    detailTitle: '酒店详情',
    saveChanges: '保存修改',
    tabInfo: '🏢 酒店基础信息',
    tabPackages: '🛏️ 酒店套餐',
    tabEnv: '📸 酒店环境',
    tabFacilities: '🏨 酒店设施及周边',
    tabOrders: '📋 订单交易信息',
    ordersComingSoon: '订单功能即将开放',
    facadeTitle: '酒店门头图片',
    uploadImage: '📷 上传图片',
    replace: '替换',
    addFacade: '添加门头图片',
    imageHint: '💡 建议上传酒店外观/门头实拍图，单张图片不超过 5MB，最多 20 张；选图仅本地预览，点击「保存」后上传',
    facadeMaxError: '门头图片最多上传 20 张',
    name: '酒店名称',
    namePlaceholder: '如：广州天河皇冠假日酒店',
    nameRequired: '请填写酒店名称',
    star: '酒店星级',
    starUnit: '星级酒店',
    starUnset: '不设置',
    address: '酒店地址',
    addressPlaceholder: '如：广州市天河区天河路689号',
    addressRequired: '请填写酒店地址',
    phone: '酒店电话',
    phonePlaceholder: '请输入酒店电话',
    phoneRequired: '请填写酒店电话',
    icon: '酒店图标',
    maxRooms: '房间数上限',
    maxRoomsPlaceholder: '0',
    maxRoomsRequired: '请填写房间数上限',
    roomTags: '房间标签',
    roomTagsPlaceholder: '如：双人标准间 ¥580/晚,大床房 ¥680/晚（用逗号分隔）',
    contact: '酒店经理',
    contactPhone: '酒店经理电话',
    tags: '酒店标签',
    tagsPlaceholder: '用逗号分隔多个标签',
    description: '酒店描述',
    descriptionPlaceholder: '描述酒店特色、设施、周边环境等',
    confirmCreate: '确认新增',
    createSuccess: '酒店已创建',
    createFailed: '创建酒店失败',
    saveSuccess: '已保存',
    saveFailed: '保存失败',
    loadFailed: '加载酒店列表失败',
    loadDetailFailed: '加载酒店详情失败',
    deleteConfirm: '确定删除酒店「{name}」吗？',
    deleteSuccess: '已删除',
    deleteFailed: '删除失败',
    uploadSuccess: '上传成功',
    uploadFailed: '上传失败',
    imageSizeError: '图片不能超过 5MB',
    imageTypeError: '仅支持 JPG、PNG、WebP 格式',
    pkgList: '房间套餐列表',
    addPkg: '新增套餐',
    editPkg: '编辑套餐',
    pkgEmpty: '暂无套餐，请先新增',
    perNight: '晚',
    roomCount: '房间总数',
    roomUnit: '间',
    booked: '已预订',
    remain: '剩余',
    breakfast: '早餐',
    breakfastYes: '含早餐',
    breakfastNo: '不含早餐',
    breakfastOptional: '可选早餐',
    pkgImages: '套餐图片',
    addImage: '添加图片',
    pkgImageHint: '💡 建议上传房间实拍图，单张不超过 5MB；选图仅本地预览，确认保存套餐时上传',
    pkgName: '套餐名称',
    pkgNameRequired: '请填写套餐名称',
    beds: '床型',
    area: '面积',
    price: '价格（元/晚）',
    pkgDesc: '套餐描述',
    pkgSaveSuccess: '套餐已保存',
    pkgSaveFailed: '套餐保存失败',
    pkgDeleteConfirm: '确定删除该套餐吗？',
    pkgDeleteSuccess: '套餐已删除',
    pkgDeleteFailed: '删除套餐失败',
    envTip: '环境图用于展示酒店大堂、餐厅、会议室等公共空间；选图仅本地预览，点击「保存」后上传',
    envTitle: '酒店图片',
    clickUpload: '点击上传',
    facilitiesTitle: '酒店设施',
    facilityPlaceholder: '输入新设施名称',
    add: '添加',
    surroundingsTitle: '周边环境',
    surroundingsPlaceholder: '可填写周边景点、交通、餐饮等信息（支持纯文本或简单 HTML）',
    surroundingsHint: '保存时将写入 surroundings 字段；支持纯文本或 HTML',
  }
}
